export const isDevelop = import.meta.env.DEV;

export const settings = {
  localeSelectorEnabled: true,
  activityViewEnabled: true,
  chatEnabled: false,
  statementsEnabled: true,
  avatarChangerEnabled: false,
  useGatedRefs: true
} as const;
